import { Pipe, PipeTransform } from '@angular/core';
import {LeagueCompetitorRoundResult, LeaguePoints, LeagueRoundResultContext} from '@model';

@Pipe({
    name: 'leagueRank',
    standalone: false
})
export class LeagueRankPipe implements PipeTransform {

    transform(points: LeaguePoints | undefined, rankType: 'absolute' | 'gender' | 'category',
              context: LeagueRoundResultContext | undefined | null = LeagueRoundResultContext.ROUND,
              result?: LeagueCompetitorRoundResult): number | null | undefined {
        if (context === LeagueRoundResultContext.RACE) {
            switch (rankType) {
                case 'category': return result?.raceCategoryRank;
                case 'gender': return result?.raceSexRank;
                default: return result?.raceAbsoluteRank;
            }
        } else {
            switch (rankType) {
                case 'category': return points?.categoryRank;
                case 'gender': return points?.genderRank;
                default: return points?.absoluteRank;
            }
        }
    }
}